import * as React from 'react';
import { observer } from 'mobx-react';
import { Card } from '@/UiBuilder/Card/Card';

import { TextAttributeCfgUIElementState } from '@/stores/TextAttributeCfgUIElementState';
import { AttributeCfgUIElement } from '@/UiBuilder/elements/AttributeCfgUIElement/AttributeCfgUIElement';
import { IAttributeTextData } from '@canvas-logic/clp-domain';
import classNames from 'classnames';

interface Props {
  state: TextAttributeCfgUIElementState;
  textData: IAttributeTextData;
}

export const TextAttributeCfgUIElement = observer(function TextAttributeCfgUIElement({ state, textData }: Props) {
  const { uiControl } = state.viewElement;
  const itemOptions = uiControl.itemOptions;
  const cardOrientation = uiControl.layout === 'card' ? 'vertical' : 'horizontal';
  if (!state.visible) {
    return null;
  }

  return (
    <AttributeCfgUIElement state={state} textData={textData}>
      <ul className={classNames('cp-attribute__options', uiControl.layout === 'card' && 'cp-attribute__options--card')}>
        {state.availableValues.map((value) => {
          const isSelected = state.value === value;
          const text = state.textData.values.find((it) => it.value === value);

          return (
            <li key={value} className={'cp-attribute__option'}>
              <Card
                orientation={cardOrientation}
                value={value}
                onSelect={state.setValue}
                selected={isSelected}
                label={itemOptions?.showTitle ? text?.label || value : ''}
                imageSrc={itemOptions?.showImage && text?.image?.url}
                imageType="icon"
                description={itemOptions?.showDescription ? text?.description : ''}
              />
            </li>
          );
        })}
      </ul>
    </AttributeCfgUIElement>
  );
});
